module.exports = __webpack_public_path__ + "static/media/icon-terminal.f56116d6.svg";